import React, { FC } from 'react';
import { createPortal } from 'react-dom';
import classNames from 'classnames';

//TODO: split into a shared modal styles and specific styles
import sharedStyles from './howItWorks.module.css';
import styles from './resumeGameModal.module.css';

const mountingPoint = document.body;

interface ResumeGameModalProps {
  onExit: () => void;
  onResume: () => void;
}

export const ResumeGameModal: FC<ResumeGameModalProps> = ({ onExit, onResume }) => {
  return createPortal(
    <div
      className={classNames(sharedStyles.pageOverlay, sharedStyles.full, styles.resumeGameModal)}
    >
      <div className={sharedStyles.howItWorks}>
        <h1 className={sharedStyles.title}>Whoa!</h1>
        <a
          href="#"
          onClick={(e) => {
            e.preventDefault();
            onResume();
          }}
          className={sharedStyles.close}
        >
          X
        </a>
        <div className={sharedStyles.body}>Do you want to exit today's puzzle?</div>
        <footer className={classNames(sharedStyles.footer, styles.footer)}>
          <button onClick={onExit} className="button">
            Exit
          </button>
          <button onClick={onResume} className="button">
            Resume
          </button>
        </footer>
      </div>
    </div>,
    mountingPoint,
  );
};
